export const CONSTANTS = {
    clientTypes: [
        { clientID: 1, label: 'Client' },
        { clientID: 2, label: 'Opposing Side Party' },
        { clientID: 3, label: 'Case Counsel' }
    ],
    caseType: [
        { value: 1, label: 'RCA - Rent Control Appeal' },
        { value: 2, label: 'RCOP - Rent Control Original Peition' },
        { value: 3, label: 'RCS - Referred Charge Sheet' },
        { value: 4, label: 'RLTOP - Regulation of Rights and Responsibilities of Landlord and Tenant Original Petition' },
        { value: 5, label: 'RP - Review Petition' },
        { value: 6, label: 'RTA - Rent Tribunal Appeal' },
        { value: 7, label: 'SA - Second Appeal' },
        { value: 8, label: 'SC - Sessions Case' },
        { value: 9, label: 'SCC - Small Cause Suit' },
        { value: 10, label: 'SOA - Standing Order Appeal' },
        { value: 11, label: 'SOP - Succession Original Petition' },
        { value: 12, label: 'SPLCC - Special Calendar Case' },
        { value: 13, label: 'SPL SC - Special Caccinne Paco' },
        { value: 14, label: 'EP - Execution Petition' },
        { value: 15, label: 'IP - Insolvency Petition' },
        { value: 16, label: 'JC - Juvenile Case' },
        { value: 17, label: 'MC - Maintenance Case' },
        { value: 18, label: 'MCOP - Motor Accidents Claim Original Petition' },
        { value: 19, label: 'MJC - Miscellaneous Judicial Case' },
        { value: 20, label: 'MTA - Municipal Taxation Appeal' },
        { value: 21, label: 'NT Application - New Trial Application' },
        { value: 22, label: 'OA - Original Application' },
        { value: 23, label: 'OP - Original Petition' },
        { value: 24, label: 'OS - Original Suit' },
        { value: 25, label: 'PRC - Preliminary Register Case' },
        { value: 26, label: 'PWA - Payment Wages Appeal' },
        { value: 27, label: 'RC - Reference Case' },
        { value: 28, label: 'AP - Approval Petition' },
        { value: 29, label: 'AS - Appeal Suit' },
        { value: 30, label: 'C - Complaint Petition' },
        { value: 31, label: 'CC - Calendar Case' },
        { value: 32, label: 'CMA - Civil Miscellaneous Appeal' },
        { value: 33, label: 'CP - Claim Petition' },
        { value: 34, label: 'CRLA - Criminal Appeal' },
        { value: 35, label: 'CRLMP - Criminal Miscellaneous Petition' },
        { value: 36, label: 'CRLR - Criminal Revision Petition' },
        { value: 37, label: 'CRP - Civil Revision Petition' },
        { value: 38, label: 'Dist. Application - Distress Application' },
        { value: 39, label: 'DVC - Domestic Violence Case' },
        { value: 40, label: 'EOCC - Economic Offence Case' }
    ],

    caseStatus: [
        { value: 0, label: 'all' },
        { value: 1, label: 'open' },
        { value: 2, label: 'my-case' },
    ],
    userType: [
        { userType: 1, label: "Admin" },
        { userType: 2, label: "Senior" },
        { userType: 3, label: "Junior" }
    ],
    courtOfPractice: [
        {id: 1, label: "High Court"},
        {id: 2, label: "District Court"},
    ],
    areasOfPractice: [
        { id: 1, label: 'Criminal' },
        { id: 2, label: 'Civil' },
        { id: 3, label: 'Family' },
        { id: 4, label: 'Corporate' }
    ]
}




